import React, { useState, useEffect, useContext } from 'react'

import { Sheet, PAYPAL_THEME } from '@paypalcorp/pp-react'
import { ThemeProvider } from '@emotion/react'
import { MessageFormat } from '@paypalcorp/worldready'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'

// components
import {
  CreateComponent,
  sessionTimerHoc,
  PrivacyModal,
} from '../../components'
import SubHeader from './sub-header'
import DWSubHeader from './dw-sub-header'
import MerchantSubHeader from './merchant-sub-header'
import PrivacyHub from '../privacyhub/PrivacyHubHome'
import PrivacyHub2 from '../privacyhub'
import { DSRZettleHome } from '../dsr'
import ReTriggerSMS from '../retriggersms'
// utils
import { fptiCustomSetup, serverData, modalStyleConfig } from '../../utils'
import TetherID from '../tetherid'

const { selectedComponent, pageName = 'home', keys = {} } = serverData

const Home = (props) => {
  const {
    children = null,
    isFlow = false,
    showBackButton = false,
    backUrl = '',
    closeUrl = '',
    domid = '',
  } = props
  const { elmoFlags = {}, locality = {} } = serverData
  const directionality = locality.directionality || 'ltr'
  const { xe = '' } = elmoFlags.tracking
  const { xt = '' } = elmoFlags.tracking
  const fptiData = {
    pgrp: `main:dataprivacy:${pageName}`,
    page: `main:dataprivacy:${pageName}`,
    pglk: `main:dataprivacy:${pageName}:data_privacy`,
    xe,
    xt,
  }
  const [modalInfo, setModalInfo] = useState({})
  const [impressionDone, setImpressionDone] = useState(false)
  const [position, setPosition] = useState(0)
  const [modalParams, setModalParams] = useState({})
  const navigateToUrl = (url) => {
    window.location.href = url
  }
  const resetState = () => {
    setModalInfo({})
    const closeBtnClickState = closeUrl
      ? navigateToUrl(closeUrl)
      : setPosition(0)
    return closeBtnClickState
  }
  const worldReady = useContext(WorldReadyContext)

  const onBackButtonClick = (event) => {
    event.preventDefault()
    const backBtnClickState = backUrl
      ? navigateToUrl(backUrl)
      : setPosition(position - 1)
    return backBtnClickState
  }
  const setModalStore = (param) => {
    Object.assign(modalParams, param)
  }
  const onCloseModal = () => resetState()

  const onSectionClick = (modal) => setModalInfo(modal)

  const { slides = [], redirect = '' } = props
  useEffect(() => {
    setPosition(props.position)
    setModalParams({})
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(fptiData)
    }
  }, [])

  const childProps = {
      ...modalInfo,
      position,
      slides,
      redirect,
      modalParams,
      updateModalStore: setModalStore,
      onModalNavigate: setPosition,
    },
    modalStyle = modalStyleConfig(directionality)
  const isModalOpen = isFlow ? true : !!modalInfo.name
  const renderChildren = () => React.Children.map(children, (child) => child)
  const shouldShowBackBtn =
    showBackButton || (position > 0 && position < slides.length - 1)
  const sheetComponent = (
    <ThemeProvider theme={PAYPAL_THEME}>
      <Sheet
        noPadding
        headerClassName="privacy-sheet-header"
        className="privacy-sheet-content"
        isOpen={isModalOpen}
        onClose={onCloseModal}
        title={childProps.title}
        mobileFixedHeight={'90'}
        style={{ direction: directionality }}
        skipFormFocus={true}
      >
        <CreateComponent {...childProps} />
      </Sheet>
    </ThemeProvider>
  )
  const modalComponent = (
    <PrivacyModal
      overpanel
      isOpen={isModalOpen}
      onClose={onCloseModal}
      style={modalStyle}
      id={domid || modalInfo.name || ''}
      action={shouldShowBackBtn}
      onBackButtonClick={onBackButtonClick}
      closeOnBackgroundClick={isFlow ? false : true}
      hideTitle={true}
      closeButtonLabel={new MessageFormat(worldReady, {
        id: `app.modal.closeButton`,
      }).format()}
    >
      <ThemeProvider theme={PAYPAL_THEME}>
        {(isFlow && slides.length && <CreateComponent {...childProps} />) ||
          (isFlow && renderChildren()) || <CreateComponent {...childProps} />}
      </ThemeProvider>
    </PrivacyModal>
  )

  const PrivacyComponents = {
    default: (
      <div>
        <SubHeader onSectionClick={onSectionClick} /> {modalComponent}
      </div>
    ),
    merchant: (
      <div>
        <MerchantSubHeader onSectionClick={onSectionClick} /> {modalComponent}
      </div>
    ),
    dw2: (
      <div>
        <DWSubHeader onSectionClick={onSectionClick} /> {sheetComponent}
      </div>
    ),
    privacyhub: (
      <>
        <PrivacyHub onSectionClick={onSectionClick} keys={keys} {...props} />{' '}
        {modalComponent}
      </>
    ),
    privacyhub2: (
      <>
        <PrivacyHub2 onSectionClick={onSectionClick} keys={keys} {...props} />{' '}
        {sheetComponent}
      </>
    ),
    zettle: (
      <div className="zettleContainer">
        <DSRZettleHome onSectionClick={onSectionClick} keys={keys} {...props} />{' '}
      </div>
    ),
    retriggersms: (
      <div>
        <ReTriggerSMS keys={keys} {...props} />
      </div>
    ),
    tid: (
      <>
        <TetherID onSectionClick={onSectionClick} /> {sheetComponent}
      </>
    ),
  }
  const selectedComponentToRender = (
    <div data-testid="home-page">
      <ThemeProvider theme={PAYPAL_THEME}>
        {!selectedComponent
          ? PrivacyComponents.default
          : PrivacyComponents[selectedComponent]}
      </ThemeProvider>
    </div>
  )
  const componentToRender = isFlow ? modalComponent : selectedComponentToRender

  return componentToRender
}

export default sessionTimerHoc(Home)
